import cn from 'classnames'
import { Link } from 'react-router-dom'

import { FlashingArrow } from 'components/FlashingArrow/FlashingArrow'

import styles from './seeMoreItem.module.scss'

interface Props {
    text: string
    action: string
    sectionKey?: string
}

export const SeeMoreItem = ({ text, action,  sectionKey }: Props) => {
    return (
        <div className={styles.wrapper}>
                  <Link
        to={action}
        className={cn(styles.link, {
          [styles.subscriptionLink]: sectionKey === 'subscriptions'
        })}
      >
                <div className={styles.icon}>
                    <FlashingArrow side='right' color='#778797' />
                </div>
                <div className={styles.text}>{text}</div>
            </Link>
        </div>
    )
}
